<template>
    <main class="main-content main-content-blogs">
        <div class="container-fluid container-specials">
            <div class="row">
                <div class="col-12">
                    <p class="specials-title"><strong>Blogs</strong></p>
                </div>
            </div>
        </div>

        <div class="container container-banner">
            <div class="row">
                <div class="col-12">
                    <div id='div-gpt-ad-1603501550614-0'></div>
                </div>
            </div>
        </div>

        <div class="container-fluid container-noticies-block container-blogs">
            <div class="container container-blogs-page">
                <div class="row" v-if="blogs">
                    <div class="col-6 col-md-4 col-lg-4" v-for="blog in blogs" :key="blog.id">
                        <a class="blog-item" target="_blank" :href="blog.latest.url">
                            <div class="blog-item__imagem-name">
                                <img v-if="blog.image" :src="utils.image(blog.image, 240, 336)" alt="" />
                                <p class="blog-item__name"><strong>{{ blog.title }}</strong></p>
                            </div>
                            <div class="blog-item__info">
                                <div class="blog-item__description" style="height:200px">
                                    <p class="blog-item__name"><strong>{{ blog.title }}</strong></p>
                                    <strong>{{blog.latest.title}}</strong>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import api from '@/api'
import utils from '@/utils'

export default {
    name: 'Blogs',
    head:{
        title:{
            inner: 'Blogs'
        }
    },
    data() {
        return {
            utils: utils,
            blogs: null
        }
    },
    methods: {
        async getBlogs() {
            const response = await api.get('blogs/',{
                type: 'blogs.BlogPage',
                fields:'url,latest,image',
            })

            if (response.ok) {
                this.blogs = response.data.items
            }
        }
    },
    mounted() {
        this.getBlogs()
        var googletag = window.googletag
        googletag.cmd.push(function() {
            googletag.destroySlots()
            googletag.defineSlot('/1513505/v1_gweb_superbanner_topo', [[970,250], [300, 100], [728, 90]], 'div-gpt-ad-1603501550614-0').addService(googletag.pubads());
            googletag.pubads().enableSingleRequest()
            googletag.pubads().collapseEmptyDivs()
            googletag.enableServices()
            googletag.display('div-gpt-ad-1603501550614-0')
        })
    }
}
</script>